<template lang="pug">
    .checkbox-row
        label.checkbox-label(:for='inputId')
            template(v-if="bindValueToList > 0")
                input.checkbox-input(
                    type='checkbox',
                    :id='inputId',
                    :name='attributeName',
                    :data-attribute-name='attributeName',
                    :value='bindValueToList',
                    v-model='model[attributeName]',
                )
            template(v-else="")
                input.checkbox-input(
                    type='checkbox',
                    :id='inputId',
                    :data-attribute-name='attributeName',
                    v-model='model[attributeName]',
                )
            span(v-html="label")
            .js-search-advanced-filter-checkbox-popover.rover-icon.rover-icon-in-question-circle(
                v-if='tooltipText',
                :data-content='tooltipText',
                data-container='body',
                data-trigger='hover',
                data-placement='bottom',
                data-original-title='',
                title='',
            )
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
            },
            attributeName: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            inputId: {
                type: String,
                required: true,
            },
            tooltipText: {
                type: String,
                required: false,
                default: '',
            },
            /**
             * Pass an integer (e.g., a PK) to this property to have it treat the model attribute
             *  as a list, with values shared among all other CheckboxRows with the same attributeName.
             *
             *  E.g. if attributeName for a group of CheckboxRows is 'pets', and the checkboxes with
             *  values 1 and 3 are checked, then model.pets would be [1, 3].
             */
            bindValueToList: {
                type: Number,
                required: false,
                default: -1,
            },
        },
    };
</script>

<style lang="scss">
    @import '../../../../css/utilities/mixins';

    .checkbox-row {
        @include responsive-spacing('margin-bottom', 2);
        .checkbox-label { font-weight: normal; }
        .checkbox-input {
            @include responsive-spacing('margin-right', 2);
        }
        .rover-icon-in-question-circle {
            @include responsive-spacing('margin-left', 1);
        }
    }
</style>



// WEBPACK FOOTER //
// CheckboxRow.vue?73571d00